import { FC, MouseEventHandler } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import SVG from 'react-inlinesvg'
import { Colour } from '../constants'
import darkPlus from '@/assets/icons/plusBlack.svg'

export interface IconographyButtonProps {
  icon: string | { src: string }
  handler: MouseEventHandler
  disabled?: boolean
  value: string
  className?: string
  hollow?: boolean
  colour?: string
}

export const IconographyButton: FC<IconographyButtonProps> = ({
  icon,
  handler,
  disabled = false,
  value,
  className,
  hollow,
  colour = Colour.fuschiaPunch,
}) => {
  const darkIcon = [Colour.warmStone, Colour.teal10].includes(colour as Colour)
  const iconSrc = typeof icon === 'string' ? icon : icon.src
  const darkPlusSrc = typeof darkPlus === 'string' ? darkPlus : darkPlus.src

  return (
    <button
      type="button"
      value={value}
      aria-label={value}
      className={cx(styles.button, className, [styles[colour]], {
        [styles.hollow]: Boolean(hollow),
      })}
      disabled={disabled}
      onKeyDown={e => e.stopPropagation()}
      onClick={handler}
    >
      <SVG src={darkIcon ? darkPlusSrc : iconSrc} className={styles.icon} />
    </button>
  )
}
